/**
 * One month of the range calendar. Days before today cannot be picked, except
 * a day that is already one of the ends.
 */
import { CALENDAR_CELL, CalendarDay } from './CalendarDay';
import { daysInMonth, monthGrid, type DateKey } from './date-keys';

const WEEKDAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const GRID = { display: 'grid', gridTemplateColumns: `repeat(7, ${CALENDAR_CELL}px)` } as const;

export interface CalendarMonthProps {
  year: number;
  month: number;
  /** The band as drawn, which follows the pointer while picking. */
  bandStart: DateKey;
  bandEnd: DateKey;
  selected: readonly DateKey[];
  today: DateKey;
  onPick: (day: DateKey) => void;
  onHover: (day: DateKey | null) => void;
}

export function CalendarMonth(p: CalendarMonthProps) {
  const lastDay = daysInMonth(p.year, p.month);
  return (
    <div className="dtr-month" style={{ width: CALENDAR_CELL * 7 }}>
      <div style={{ ...GRID, marginBottom: 2 }} aria-hidden="true">
        {WEEKDAYS.map((w) => (
          <span
            key={w}
            style={{
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 10.5,
              fontWeight: 700,
              color: 'var(--nb-faint)',
            }}
          >
            {w}
          </span>
        ))}
      </div>
      <div style={{ ...GRID, rowGap: 2 }} onMouseLeave={() => p.onHover(null)}>
        {monthGrid(p.year, p.month).map((day, i) => {
          if (!day) return <span key={`blank-${i}`} />;
          const date = Number(day.slice(8));
          return (
            <CalendarDay
              key={day}
              day={day}
              inBand={p.bandStart !== p.bandEnd && day >= p.bandStart && day <= p.bandEnd}
              endpoint={day === p.bandStart || day === p.bandEnd}
              roundLeft={day === p.bandStart || i % 7 === 0 || date === 1}
              roundRight={day === p.bandEnd || i % 7 === 6 || date === lastDay}
              disabled={day < p.today && !p.selected.includes(day)}
              isToday={day === p.today}
              onPick={p.onPick}
              onHover={p.onHover}
            />
          );
        })}
      </div>
    </div>
  );
}
